export default "__VITE_ASSET__BJNajLn9__"